import AdminDashboardComponent from "./admin-dasboard";
import { useSelector, useDispatch } from "react-redux";
import * as app from "/src/app/app.slice";
import * as adminSlice from "./admin.slice";
import { useHistory } from "react-router-dom";

function AdminDashboard() {
  const dispatch = useDispatch();
  const history = useHistory();
  var announcements = useSelector(app.selectAnnouncements);
  var status = useSelector(app.selectStatus);
  var sort = useSelector(adminSlice.selecSortFilter);

  const handleVisuraClick = () => {
    history.push("/admin/6484ec7b/visura");
  };

  const handleCreateClick = () => {
    history.push("/admin/create-announcement/default");
  };

  const handleLoadTecnicalPdfClick = () => {
    history.push("/admin/6484ec7b/load-pdf");
  };

  const handleOrderAscClick = () => {
    dispatch(adminSlice.setSortFilter({ sort: adminSlice.SORT.ASC }));
  };

  const handleOrderDescClick = () => {
    dispatch(adminSlice.setSortFilter({ sort: adminSlice.SORT.DESC }));
  };

  return (
    <AdminDashboardComponent
      announcements={announcements}
      status={status}
      onCreateClick={handleCreateClick}
      onOrderAscClick={handleOrderAscClick}
      onOrderDescClick={handleOrderDescClick}
      onVisuraClick={handleVisuraClick}
      onLoadTecnicalPdfClick={handleLoadTecnicalPdfClick}
      sort={sort}
    />
  );
}

export default AdminDashboard;
